import React, { useState } from 'react';
import { login, register } from "../api";
import InstagramLink from './InstagramLink';
import SelectPersonalizado from './SelectPersonalizado';
import RecuperarContrasena from './RecuperarContrasena';

const INSTAGRAM_HANDLE = '@SoftCraftSolutionsSde';
const INSTAGRAM_URL = 'https://www.instagram.com/SoftCraftSolutionsSde';

// El mensaje de trial vencido viene del backend como texto plano (ver
// TRIAL_EXPIRED_DETAIL en accounts/utils.py); acá solo convertimos la
// mención del handle en un link, sin tocar el resto del texto.
function conLinkInstagram(mensaje) {
  const partes = mensaje.split(INSTAGRAM_HANDLE);
  if (partes.length === 1) return mensaje;
  return partes.reduce((acc, parte, i) => {
    if (i > 0) {
      acc.push(
        <a key={`ig-${i}`} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="login-trial-instagram">
          {INSTAGRAM_HANDLE}
        </a>
      );
    }
    acc.push(parte);
    return acc;
  }, []);
}

const PROFESSION_CHOICES = [
  { value: 'psychologist',    label: 'Psicología' },
  { value: 'psychiatrist',    label: 'Psiquiatría' },
  { value: 'nutritionist',    label: 'Nutrición' },
  { value: 'general_doctor',  label: 'Medicina General' },
  { value: 'pediatrician',    label: 'Pediatría' },
  { value: 'dentist',         label: 'Odontología' },
  { value: 'physiotherapist', label: 'Kinesiología' },
  { value: 'other',           label: 'Otra' },
];

function Login({ onLogin }) {
  const [modo, setModo] = useState('login'); // 'login' | 'registro' | 'recuperar'
  const [mensajeExito, setMensajeExito] = useState('');

  // Mensaje de trial vencido — puede llegar de un login rechazado (403
  // directo) o de un refresh fallido en otra pestaña/sesión (guardado en
  // localStorage por fetchWithAuth antes de recargar la página).
  const [bloqueoTrial, setBloqueoTrial] = useState(() => {
    const guardado = localStorage.getItem('trialExpiredMessage');
    if (guardado) localStorage.removeItem('trialExpiredMessage');
    return guardado || '';
  });

  // login
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');

  // registro
  const [regNombre, setRegNombre]         = useState('');
  const [regApellido, setRegApellido]     = useState('');
  const [regUsername, setRegUsername]     = useState('');
  const [regEmail, setRegEmail]           = useState('');
  const [regPassword, setRegPassword]     = useState('');
  const [regPassword2, setRegPassword2]   = useState('');
  const [regProfesion, setRegProfesion]   = useState('');
  const [regAceptaPrivacidad, setRegAceptaPrivacidad] = useState(false);
  const [registroOk, setRegistroOk]       = useState(false);

  const [error, setError]       = useState('');
  const [cargando, setCargando] = useState(false);

  const cambiarModo = (m) => { setModo(m); setError(''); setRegistroOk(false); setMensajeExito(''); };

  const manejarLogin = async (e) => {
    e.preventDefault();
    if (!usuario || !contrasena) { setError('Por favor completa todos los campos.'); return; }
    setCargando(true);
    try {
      const userData = await login(usuario, contrasena);
      setError('');
      onLogin(userData);
    } catch (err) {
      if (err.trialExpired) {
        setBloqueoTrial(err.message);
      } else {
        setError(err.message || 'Error al conectar con el servidor.');
      }
    } finally {
      setCargando(false);
    }
  };

  const manejarRegistro = async (e) => {
    e.preventDefault();
    if (!regNombre || !regApellido || !regUsername || !regEmail || !regPassword || !regPassword2) {
      setError('Por favor completa todos los campos obligatorios.');
      return;
    }
    if (regPassword !== regPassword2) { setError('Las contraseñas no coinciden.'); return; }
    if (!regAceptaPrivacidad) { setError('Debés leer y aceptar la Política de Privacidad para registrarte.'); return; }
    setCargando(true);
    try {
      await register({
        username: regUsername,
        password: regPassword,
        first_name: regNombre,
        last_name: regApellido,
        email: regEmail,
        profession: regProfesion,
      });
      setError('');
      setRegistroOk(true);
    } catch (err) {
      setError(err.message || 'Error al registrarse.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">

        <div className="login-izquierda">
          <div className="login-marca">
            <img src="/LogoSoftCraft.png" alt="Logo" className="login-logo" />
            <h1 className="login-marca-titulo">SoftCraftSolutionsSde</h1>
            <p className="login-marca-subtitulo">Sistema de gestión de pacientes</p>
          </div>
        </div>

        <div className="login-derecha">
          {bloqueoTrial ? (
            <div className="login-card">
              <p className="login-subtitulo">Período de prueba vencido</p>
              <p style={{ marginBottom: 16 }}>{conLinkInstagram(bloqueoTrial)}</p>
              <button className="login-btn" onClick={() => setBloqueoTrial('')}>
                Volver a iniciar sesión
              </button>
            </div>
          ) : modo === 'recuperar' ? (
            <div className="login-card">
              <p className="login-titulo">Recuperar contraseña</p>
              <RecuperarContrasena
                onVolverALogin={(msg) => { setModo('login'); setError(''); setMensajeExito(msg); }}
              />
            </div>
          ) : (
          <div className="login-card">

            {/* Tabs login / registro */}
            <div className="login-tabs">
              <button
                className={`login-tab${modo === 'login' ? ' login-tab-activo' : ''}`}
                onClick={() => cambiarModo('login')}
                type="button"
              >
                Iniciar Sesión
              </button>
              <button
                className={`login-tab${modo === 'registro' ? ' login-tab-activo' : ''}`}
                onClick={() => cambiarModo('registro')}
                type="button"
              >
                Registrarse
              </button>
            </div>

            {/* ── Login ── */}
            {modo === 'login' && (
              <>
                <p className="login-subtitulo">Ingresa tus credenciales para continuar</p>
                {mensajeExito && <p className="login-mensaje-exito">{mensajeExito}</p>}
                <form className="login-form" onSubmit={manejarLogin}>
                  <label className="login-label">
                    Usuario
                    <input
                      type="text"
                      className="login-input"
                      placeholder="Ingresa tu usuario"
                      value={usuario}
                      onChange={(e) => setUsuario(e.target.value)}
                    />
                  </label>
                  <label className="login-label">
                    Contraseña
                    <input
                      type="password"
                      className="login-input"
                      placeholder="Ingresa tu contraseña"
                      value={contrasena}
                      onChange={(e) => setContrasena(e.target.value)}
                    />
                  </label>
                  {error && <p className="login-error">{error}</p>}
                  <button type="submit" className="login-btn" disabled={cargando}>
                    {cargando ? 'Ingresando...' : 'Iniciar Sesión'}
                  </button>
                  <button
                    type="button"
                    className="login-link-secundario"
                    onClick={() => { setModo('recuperar'); setError(''); setMensajeExito(''); }}
                  >
                    ¿Olvidaste tu contraseña?
                  </button>
                </form>
              </>
            )}

            {/* ── Registro ── */}
            {modo === 'registro' && (
              <>
                {registroOk ? (
                  <div className="login-registro-ok">
                    <p>✓ Cuenta creada correctamente.</p>
                    <p>
                      {regProfesion
                        ? 'Tu solicitud de profesión quedó pendiente de aprobación por un administrador.'
                        : 'Un administrador te asignará tu profesión próximamente.'}
                    </p>
                    <p>Ya podés iniciar sesión con tu usuario y contraseña.</p>
                    <button className="login-btn" onClick={() => cambiarModo('login')}>
                      Ir a iniciar sesión
                    </button>
                  </div>
                ) : (
                  <>
                    <p className="login-subtitulo">Crea tu cuenta. Un admin aprobará tu profesión.</p>
                    <form className="login-form" onSubmit={manejarRegistro}>
                      <div className="login-fila-2">
                        <label className="login-label">
                          Nombre *
                          <input className="login-input" value={regNombre} onChange={e => setRegNombre(e.target.value)} placeholder="Nombre" />
                        </label>
                        <label className="login-label">
                          Apellido *
                          <input className="login-input" value={regApellido} onChange={e => setRegApellido(e.target.value)} placeholder="Apellido" />
                        </label>
                      </div>
                      <label className="login-label">
                        Usuario *
                        <input className="login-input" value={regUsername} onChange={e => setRegUsername(e.target.value)} placeholder="Nombre de usuario" autoComplete="username" />
                      </label>
                      <label className="login-label">
                        Email *
                        <input className="login-input" type="email" value={regEmail} onChange={e => setRegEmail(e.target.value)} placeholder="Email" />
                      </label>
                      <div className="login-fila-2">
                        <label className="login-label">
                          Contraseña *
                          <input className="login-input" type="password" value={regPassword} onChange={e => setRegPassword(e.target.value)} placeholder="Min. 8 caracteres" autoComplete="new-password" />
                        </label>
                        <label className="login-label">
                          Repetir contraseña *
                          <input className="login-input" type="password" value={regPassword2} onChange={e => setRegPassword2(e.target.value)} placeholder="Repetir contraseña" autoComplete="new-password" />
                        </label>
                      </div>
                      <p className="form-ayuda-password">
                        Mínimo 8 caracteres. No puede ser una contraseña muy común, completamente numérica, ni muy parecida a tu usuario, nombre o email.
                      </p>
                      <div className="login-label">
                        <span id="reg-profesion-label">Profesión (opcional — quedará pendiente de aprobación)</span>
                        <SelectPersonalizado
                          id="reg-profesion"
                          ariaLabelledBy="reg-profesion-label"
                          options={PROFESSION_CHOICES}
                          value={regProfesion}
                          onChange={setRegProfesion}
                          placeholder="Seleccionar profesión..."
                        />
                      </div>
                      <label className="login-checkbox-fila">
                        <input
                          type="checkbox"
                          checked={regAceptaPrivacidad}
                          onChange={e => setRegAceptaPrivacidad(e.target.checked)}
                        />
                        <span>
                          Leí y acepto la{' '}
                          <a href="/privacidad" target="_blank" rel="noopener noreferrer">
                            Política de Privacidad
                          </a>
                        </span>
                      </label>
                      {error && <p className="login-error">{error}</p>}
                      <button type="submit" className="login-btn" disabled={cargando}>
                        {cargando ? 'Registrando...' : 'Crear cuenta'}
                      </button>
                    </form>
                  </>
                )}
              </>
            )}
          </div>
          )}
        </div>

      </div>

      <footer className="footer">
        <div className="footer-izquierda">
          <img src="/LogoSoftCraft.png" alt="Logo" className="footer-logo" />
          <span className="footer-nombre">SoftCraftSolutionsSde</span>
        </div>

        <div className="footer-centro">
          {"© "}{new Date().getFullYear()}{" - Desarrollado por SoftCraftSolutionsSde"}
        </div>

        <div className="footer-derecha">
          <a href="/privacidad" target="_blank" rel="noopener noreferrer" className="footer-privacidad">
            Política de Privacidad
          </a>
          <InstagramLink />
        </div>
      </footer>
    </div>
  );
}

export default Login;
